// import React, { useState, useEffect, useRef } from "react";

// const SearchDropdown = ({
//   initialOptions = [],
//   onSelect,
//   placeholder = "Search...",
//   label = "Search Dropdown",
//   labelKey = (option) => option.label, // Function to get the label from an option
//   dropdownStyle = {},
//   inputStyle = {},
//   optionStyle = {},
//   optionClassName = "",
// }) => {
//   const [searchKey, setSearchKey] = useState(""); // User's input
//   const [filteredOptions, setFilteredOptions] = useState(initialOptions); // Filtered options
//   const [showOptions, setShowOptions] = useState(false); // Dropdown visibility
//   const [selectedOption, setSelectedOption] = useState(null); // Selected option
//   const dropdownRef = useRef(null);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowOptions(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Filter options based on user input
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(initialOptions);
//     } else {
//       setFilteredOptions(
//         initialOptions.filter((option) =>
//           labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//   }, [searchKey, initialOptions, labelKey]);

//   // Handle selection on Enter key
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && filteredOptions.length > 0) {
//       const firstOption = filteredOptions[0];
//       handleSelect(firstOption);
//     }
//   };

//   const handleSelect = (option) => {
//     setSelectedOption(option); // Save the selected option
//     onSelect(option); // Pass the selected option to the parent
//     setSearchKey(""); // Clear the search input
//     setShowOptions(false); // Close the dropdown
//   };

//   const handleClear = () => {
//     setSelectedOption(null); // Clear the selected option
//     setSearchKey(""); // Clear the search input
//     onSelect(null); // Notify the parent that the selection is cleared
//   };

//   return (
//     <div
//       className="search-dropdown"
//       style={{ position: "relative", ...dropdownStyle }}
//       ref={dropdownRef}
//     >
//       <label style={{ fontSize: "14px", color: "grey" }}>{label}</label>
//       <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
//         <input
//           type="text"
//           placeholder={selectedOption ? labelKey(selectedOption) : placeholder} // Show selected value or placeholder
//           value={searchKey}
//           onChange={(e) => {
//             setSearchKey(e.target.value);
//             setShowOptions(true); // Show dropdown while typing
//           }}
//           onKeyDown={handleKeyDown}
//           style={{
//             width: "100%",
//             padding: "8px",
//             border: "1px solid grey",
//             // borderRadius: "4px",
//             ...inputStyle,
//           }}
//         />
//         {selectedOption || searchKey ? (
//           <button
//             onClick={handleClear}
//             style={{
//               position: "absolute",
//               right: "8px",
//               background: "none",
//               border: "none",
//               color: "grey",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         ) : null}
//       </div>
//       {showOptions && (
//         <div
//           className="dropdown-options"
//           style={{
//             position: "absolute",
//             top: "100%",
//             left: 0,
//             width: "100%",
//             maxHeight: "200px",
//             overflowY: "auto",
//             border: "1px solid #ccc",
//             backgroundColor: "#fff",
//             zIndex: 1000,
//             ...dropdownStyle,
//           }}
//         >
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option, index) => (
//               <div
//                 key={index}
//                 onClick={() => handleSelect(option)}
//                 style={{
//                   padding: "8px",
//                   cursor: "pointer",
//                   ...optionStyle,
//                 }}
//                 className={optionClassName}
//               >
//                 {labelKey(option)}
//               </div>
//             ))
//           ) : (
//             <div
//               style={{
//                 padding: "8px",
//                 color: "#999",
//                 ...optionStyle,
//               }}
//             >
//               No results found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDropdown;


// import React, { useState, useEffect, useRef } from "react";

// const SearchDropdown = ({
//   initialOptions = [],
//   onSelect,
//   placeholder = "Search...",
//   label = "Search Dropdown",
//   labelKey = (option) => option.label, // Function to get the label from an option
//   dropdownStyle = {},
//   inputStyle = {},
//   optionStyle = {},
//   optionClassName = "",
// }) => {
//   const [searchKey, setSearchKey] = useState(""); // User's input
//   const [filteredOptions, setFilteredOptions] = useState(initialOptions); // Filtered options
//   const [showOptions, setShowOptions] = useState(false); // Dropdown visibility
//   const [selectedOption, setSelectedOption] = useState(null); // Selected option
//   const [focusedIndex, setFocusedIndex] = useState(-1); // Highlighted option index
//   const dropdownRef = useRef(null);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowOptions(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Filter options based on user input
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(initialOptions);
//     } else {
//       setFilteredOptions(
//         initialOptions.filter((option) =>
//           labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//     setFocusedIndex(-1); // Reset focused index when filtering options
//   }, [searchKey, initialOptions, labelKey]);

//   // Handle selection on Enter key and arrow navigation
//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
//       );
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
//       );
//     } else if (e.key === "Enter") {
//       e.preventDefault();
//       if (filteredOptions.length > 0) {
//         if (focusedIndex >= 0) {
//           handleSelect(filteredOptions[focusedIndex]);
//         } else {
//           // If no option is focused, default to the first option
//           handleSelect(filteredOptions[0]);
//         }
//       }
//     }
//   };

//   const handleSelect = (option) => {
//     setSelectedOption(option); // Save the selected option
//     onSelect(option); // Pass the selected option to the parent
//     setSearchKey(""); // Clear the search input
//     setShowOptions(false); // Close the dropdown
//     setFocusedIndex(-1); // Reset the focused index
//   };

//   const handleClear = () => {
//     setSelectedOption(null); // Clear the selected option
//     setSearchKey(""); // Clear the search input
//     onSelect(null); // Notify the parent that the selection is cleared
//     setFocusedIndex(-1);
//   };

//   return (
//     <div
//       className="search-dropdown"
//       style={{ position: "relative", ...dropdownStyle }}
//       ref={dropdownRef}
//     >
//       <label style={{ fontSize: "14px", color: "grey" }}>{label}</label>
//       <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
//         <input
//           type="text"
//           placeholder={selectedOption ? labelKey(selectedOption) : placeholder} // Show selected value or placeholder
//           value={searchKey}
//           onChange={(e) => {
//             setSearchKey(e.target.value);
//             setShowOptions(true); // Show dropdown while typing
//           }}
//           onKeyDown={handleKeyDown}
//           style={{
//             width: "100%",
//             padding: "8px",
//             border: "1px solid grey",
//             ...inputStyle,
//           }}
//         />
//         {(selectedOption || searchKey) && (
//           <button
//             onClick={handleClear}
//             style={{
//               position: "absolute",
//               right: "8px",
//               background: "none",
//               border: "none",
//               color: "grey",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         )}
//       </div>
//       {showOptions && (
//         <div
//           className="dropdown-options"
//           style={{
//             position: "absolute",
//             top: "100%",
//             left: 0,
//             width: "100%",
//             maxHeight: "200px",
//             overflowY: "auto",
//             border: "1px solid #ccc",
//             backgroundColor: "#fff",
//             zIndex: 1000,
//             ...dropdownStyle,
//           }}
//         >
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option, index) => (
//               <div
//                 key={index}
//                 onMouseEnter={() => setFocusedIndex(index)}
//                 onMouseLeave={() => setFocusedIndex(-1)}
//                 onClick={() => handleSelect(option)}
//                 style={{
//                   padding: "8px",
//                   cursor: "pointer",
//                   backgroundColor: index === focusedIndex ? "#f0f0f0" : "transparent",
//                   ...optionStyle,
//                 }}
//                 className={optionClassName}
//               >
//                 {labelKey(option)}
//               </div>
//             ))
//           ) : (
//             <div
//               style={{
//                 padding: "8px",
//                 color: "#999",
//                 ...optionStyle,
//               }}
//             >
//               No results found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDropdown;

// import React, { useState, useEffect, useRef } from "react";

// const SearchDropdown = ({
//   initialOptions = [],
//   onSelect,
//   placeholder = "Search...",
//   label = "Search Dropdown",
//   labelKey = (option) => option.label, // Function to get the label from an option
//   dropdownStyle = {},
//   inputStyle = {},
//   optionStyle = {},
//   optionClassName = "",
// }) => {
//   const [searchKey, setSearchKey] = useState(""); // User's input
//   const [filteredOptions, setFilteredOptions] = useState(initialOptions); // Filtered options
//   const [showOptions, setShowOptions] = useState(false); // Dropdown visibility
//   const [selectedOption, setSelectedOption] = useState(null); // Selected option
//   const [focusedIndex, setFocusedIndex] = useState(-1); // Highlighted option index
//   const dropdownRef = useRef(null);
//   const optionRefs = useRef([]); // Array of refs for each option

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowOptions(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Filter options based on user input
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(initialOptions);
//     } else {
//       setFilteredOptions(
//         initialOptions.filter((option) =>
//           labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//     setFocusedIndex(-1); // Reset focused index when filtering options
//   }, [searchKey, initialOptions, labelKey]);

//   // Scroll into view when focusedIndex changes
//   useEffect(() => {
//     if (focusedIndex > -1 && optionRefs.current[focusedIndex]) {
//       optionRefs.current[focusedIndex].scrollIntoView({
//         behavior: "smooth",
//         block: "nearest"
//       });
//     }
//   }, [focusedIndex]);

//   // Handle selection on Enter key and arrow navigation
//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
//       );
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
//       );
//     } else if (e.key === "Enter") {
//       e.preventDefault();
//       if (filteredOptions.length > 0) {
//         if (focusedIndex >= 0) {
//           handleSelect(filteredOptions[focusedIndex]);
//         } else {
//           // If no option is focused, default to the first option
//           handleSelect(filteredOptions[0]);
//         }
//       }
//     }
//   };

//   const handleSelect = (option) => {
//     setSelectedOption(option); // Save the selected option
//     onSelect(option); // Pass the selected option to the parent
//     setSearchKey(""); // Clear the search input
//     setShowOptions(false); // Close the dropdown
//     setFocusedIndex(-1); // Reset the focused index
//   };

//   const handleClear = () => {
//     setSelectedOption(null); // Clear the selected option
//     setSearchKey(""); // Clear the search input
//     onSelect(null); // Notify the parent that the selection is cleared
//     setFocusedIndex(-1);
//   };

//   return (
//     <div
//       className="search-dropdown"
//       style={{ position: "relative", ...dropdownStyle }}
//       ref={dropdownRef}
//     >
//       <label style={{ fontSize: "14px", color: "grey" }}>{label}</label>
//       <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
//         <input
//           type="text"
//           placeholder={selectedOption ? labelKey(selectedOption) : placeholder} // Show selected value or placeholder
//           value={searchKey}
//           onChange={(e) => {
//             setSearchKey(e.target.value);
//             setShowOptions(true); // Show dropdown while typing
//           }}
//           onKeyDown={handleKeyDown}
//           style={{
//             width: "100%",
//             padding: "8px",
//             border: "1px solid grey",
//             ...inputStyle,
//           }}
//         />
//         {(selectedOption || searchKey) && (
//           <button
//             onClick={handleClear}
//             style={{
//               position: "absolute",
//               right: "8px",
//               background: "none",
//               border: "none",
//               color: "grey",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         )}
//       </div>
//       {showOptions && (
//         <div
//           className="dropdown-options"
//           style={{
//             position: "absolute",
//             top: "100%",
//             left: 0,
//             width: "100%",
//             maxHeight: "200px",
//             overflowY: "auto",
//             border: "1px solid #ccc",
//             backgroundColor: "#fff",
//             zIndex: 1000,
//             ...dropdownStyle,
//           }}
//         >
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option, index) => (
//               <div
//                 key={index}
//                 ref={(el) => (optionRefs.current[index] = el)}
//                 onMouseEnter={() => setFocusedIndex(index)}
//                 onMouseLeave={() => setFocusedIndex(-1)}
//                 onClick={() => handleSelect(option)}
//                 style={{
//                   padding: "8px",
//                   cursor: "pointer",
//                   backgroundColor: index === focusedIndex ? "#f0f0f0" : "transparent",
//                   ...optionStyle,
//                 }}
//                 className={optionClassName}
//               >
//                 {labelKey(option)}
//               </div>
//             ))
//           ) : (
//             <div
//               style={{
//                 padding: "8px",
//                 color: "#999",
//                 ...optionStyle,
//               }}
//             >
//               No results found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDropdown;

// import React, { useState, useEffect, useRef } from "react";

// const SearchDropdown = ({
//   initialOptions = [],
//   onSelect,
//   onInputChange, // NEW PROP: callback when the input text changes
//   placeholder = "Search...",
//   label = "Search Dropdown",
//   labelKey = (option) => option.label, // Function to get the label from an option
//   dropdownStyle = {},
//   inputStyle = {},
//   optionStyle = {},
//   optionClassName = "",
//   selected = null,
//   required = false,
//   showError = false,

// }) => {
//   const [searchKey, setSearchKey] = useState(""); // User's input
//   const [filteredOptions, setFilteredOptions] = useState(initialOptions); // Filtered options
//   const [showOptions, setShowOptions] = useState(false); // Dropdown visibility
//   const [selectedOption, setSelectedOption] = useState(null); // Selected option
//   const [focusedIndex, setFocusedIndex] = useState(-1); // Highlighted option index
//   const dropdownRef = useRef(null);
//   const optionRefs = useRef([]); // Array of refs for each option

//   const hasError = showError && required && !selectedOption;

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowOptions(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // When initialOptions changes from the parent (or when filtering externally) update the filtered options.
//   useEffect(() => {
//     setFilteredOptions(initialOptions);
//   }, [initialOptions]);

//   // Sync external selected value with internal state
//   useEffect(() => {
//     if (selected && selectedOption?.city_id !== selected.city_id) {
//       setSelectedOption(selected);
//       setSearchKey(""); // Clear manual search key to show selected value
//     } else if (!selected) {
//       setSelectedOption(null);
//       setSearchKey("");
//     }
//   }, [selected]);


//   // Additionally filter based on the local search key (if not empty)
//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(initialOptions);
//     } else {
//       setFilteredOptions(
//         initialOptions.filter((option) =>
//           labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//     setFocusedIndex(-1); // Reset focused index when filtering options
//   }, [searchKey, initialOptions, labelKey]);

//   // Scroll into view when focusedIndex changes
//   useEffect(() => {
//     if (focusedIndex > -1 && optionRefs.current[focusedIndex]) {
//       optionRefs.current[focusedIndex].scrollIntoView({
//         behavior: "smooth",
//         block: "nearest"
//       });
//     }
//   }, [focusedIndex]);

//   // Handle keyboard navigation
//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
//       );
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setShowOptions(true);
//       setFocusedIndex((prevIndex) =>
//         prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
//       );
//     } else if (e.key === "Enter") {
//       e.preventDefault();
//       if (filteredOptions.length > 0) {
//         if (focusedIndex >= 0) {
//           handleSelect(filteredOptions[focusedIndex]);
//         } else {
//           // If no option is focused, default to the first option
//           handleSelect(filteredOptions[0]);
//         }
//       }
//     }
//   };

//   const handleSelect = (option) => {
//     setSelectedOption(option); // Save the selected option
//     onSelect(option); // Pass the selected option to the parent
//     setSearchKey(""); // Clear the search input
//     setShowOptions(false); // Close the dropdown
//     setFocusedIndex(-1); // Reset the focused index
//   };

//   const handleClear = () => {
//     setSelectedOption(null); // Clear the selected option
//     setSearchKey(""); // Clear the search input
//     onSelect(null); // Notify the parent that the selection is cleared
//     setFocusedIndex(-1);
//   };

//   return (
//     <div
//       className="search-dropdown"
//       style={{ position: "relative", ...dropdownStyle }}
//       ref={dropdownRef}
//     >
//       <label style={{ fontSize: "14px", color: "grey" }}>{label}
//         {required && <span style={{ color: '#ff0000', marginLeft: '5px' }}>*</span>}
//       </label>
//       <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
//         <input
//           type="text"
//           // placeholder={selectedOption ? labelKey(selectedOption) : placeholder} // Show selected value or placeholder
//           placeholder={selectedOption ? labelKey(selectedOption) : placeholder}
//           // value={searchKey}
//           value={searchKey || (selectedOption ? labelKey(selectedOption) : "")}
//           onChange={(e) => {
//             setSearchKey(e.target.value);
//             if (onInputChange) onInputChange(e.target.value);
//             setShowOptions(true); // Show dropdown while typing
//           }}
//           onKeyDown={handleKeyDown}
//           style={{
//             width: "100%",
//             padding: "8px",
//             color: "#6A6A6A",
//             // border: "1px solid grey",
//              border: hasError ? "1px solid #ff0000" : "1px solid grey", 
//             ...inputStyle,
//           }}
//         />
//         {(selectedOption || searchKey) && (
//           <button
//             onClick={handleClear}
//             style={{
//               position: "absolute",
//               right: "8px",
//               background: "none",
//               border: "none",
//               color: "grey",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             ✕
//           </button>
//         )}
//       </div>
//       {showOptions && (
//         <div
//           className="dropdown-options"
//           style={{
//             position: "absolute",
//             top: "100%",
//             left: 0,
//             width: "100%",
//             maxHeight: "200px",
//             overflowY: "auto",
//             border: "1px solid #ccc",
//             backgroundColor: "#fff",
//             zIndex: 1000,
//             ...dropdownStyle,
//           }}
//         >
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option, index) => (
//               <div
//                 key={index}
//                 ref={(el) => (optionRefs.current[index] = el)}
//                 onMouseEnter={() => setFocusedIndex(index)}
//                 onMouseLeave={() => setFocusedIndex(-1)}
//                 onClick={() => handleSelect(option)}
//                 style={{
//                   padding: "8px",
//                   cursor: "pointer",
//                   color: "#6A6A6A",
//                   backgroundColor: index === focusedIndex ? "#f0f0f0" : "transparent",
//                   ...optionStyle,
//                 }}
//                 className={optionClassName}
//               >
//                 {labelKey(option)}
//               </div>
//             ))
//           ) : (
//             <div
//               style={{
//                 padding: "8px",
//                 color: "#999",
//                 ...optionStyle,
//               }}
//             >
//               No results found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDropdown;



import React, { useState, useEffect, useRef } from "react";

const SearchDropdown = ({
  initialOptions = [],
  onSelect,
  onInputChange,
  placeholder = "Search...",
  label = "Search Dropdown",
  labelKey = (option) => option.label,
  dropdownStyle = {},
  inputStyle = {},
  optionStyle = {},
  optionClassName = "",
  selected = null,
  required = false,
  showError = false,
  disabled = false,
}) => {
  const [searchKey, setSearchKey] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(initialOptions);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const dropdownRef = useRef(null);
  const optionRefs = useRef([]);

  const hasError = showError && required && !selectedOption;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setFilteredOptions(initialOptions);
  }, [initialOptions]);

  // Sync external selected value with internal state
  useEffect(() => {
    if (selected && selectedOption?.city_id !== selected.city_id) {
      setSelectedOption(selected);
      setSearchKey("");
    } else if (!selected) {
      setSelectedOption(null);
      setSearchKey("");
    }
  }, [selected]);

  useEffect(() => {
    if (searchKey === "") {
      setFilteredOptions(initialOptions);
    } else {
      setFilteredOptions(
        initialOptions.filter((option) =>
          labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
        )
      );
    }
    setFocusedIndex(-1);
  }, [searchKey, initialOptions, labelKey]);

  // Scroll into view when focusedIndex changes
  useEffect(() => {
    if (focusedIndex > -1 && optionRefs.current[focusedIndex]) {
      optionRefs.current[focusedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }, [focusedIndex]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (disabled) return;
    
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowOptions(true);
      setFocusedIndex((prevIndex) =>
        prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowOptions(true);
      setFocusedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (filteredOptions.length > 0) {
        if (focusedIndex >= 0) {
          handleSelect(filteredOptions[focusedIndex]);
        } else {
          handleSelect(filteredOptions[0]);
        }
      }
    }
  };

  const handleSelect = (option) => {
    if (disabled) return;
    
    setSelectedOption(option);
    onSelect(option);
    setSearchKey("");
    setShowOptions(false);
    setFocusedIndex(-1);
  };

  const handleClear = () => {
    if (disabled) return;
    
    setSelectedOption(null);
    setSearchKey("");
    onSelect(null);
    setFocusedIndex(-1);
  };

  return (
    <div
      className="search-dropdown"
      style={{ 
        position: "relative",
        ...dropdownStyle 
      }}
      ref={dropdownRef}
    >
      <label style={{ 
        fontSize: "14px", 
        color: "grey"
      }}>
        {label}
        {required && <span style={{ color: '#ff0000', marginLeft: '5px' }}>*</span>}
      </label>
      <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
        <input
          type="text"
          placeholder={selectedOption ? labelKey(selectedOption) : placeholder}
          value={searchKey || (selectedOption ? labelKey(selectedOption) : "")}
          onChange={(e) => {
            if (disabled) return;
            setSearchKey(e.target.value);
            if (onInputChange) onInputChange(e.target.value);
            setShowOptions(true);
          }}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          style={{
            width: "100%",
            padding: "8px",
            color: "#6A6A6A",
            opacity: disabled ? 0.6 : 1,
            border: hasError ? "1px solid #ff0000" : "1px solid grey",
            cursor: disabled ? "not-allowed" : "text",
            ...inputStyle,
          }}
        />
        {(selectedOption || searchKey) && !disabled && (
          <button
            onClick={handleClear}
            style={{
              position: "absolute",
              right: "8px",
              background: "none",
              border: "none",
              color: "grey",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        )}
      </div>
      {showOptions && !disabled && (
        <div
          className="dropdown-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            zIndex: 1000,
            ...dropdownStyle,
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                ref={(el) => (optionRefs.current[index] = el)}
                onMouseEnter={() => setFocusedIndex(index)}
                onMouseLeave={() => setFocusedIndex(-1)}
                onClick={() => handleSelect(option)}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  color: "#6A6A6A",
                  backgroundColor: index === focusedIndex ? "#f0f0f0" : "transparent",
                  ...optionStyle,
                }}
                className={optionClassName}
              >
                {labelKey(option)}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: "8px",
                color: "#999",
                ...optionStyle,
              }}
            >
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;